import { CSSProperties, useCallback, useEffect, useMemo, useState } from "react"
import API from "./API"
import { AdminPersonsResponse, AdminPositionsResponse, AdminQueryPosition } from "../../backend/src/api/dto"
import dayjs from 'dayjs'
import { lookupNameFromObjectsArray } from "./global"
import { Link } from "react-router"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, closestCenter, type DragEndEvent, type UniqueIdentifier, useSensor, useSensors } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

function Positions() {

    const [data, setData] = useState<AdminPositionsResponse>({
        positions: [],
        rates: []
    })

    useEffect(() => {
        API.getPositions().then(res => {
            setData(res)
        })
    }, [])

    function handleDragEnd(event: DragEndEvent) {
        const { active, over } = event
        console.log({ active, over });
        if (active && over && active.id !== over.id) {
            setData(data => {
                const oldIndex = data.positions.findIndex(item => 'position-' + item.positionId === active.id)
                const newIndex = data.positions.findIndex(item => 'position-' + item.positionId === over.id)
                const newArray = arrayMove(data.positions, oldIndex, newIndex);
                API.sortOrder('position', newArray.map(item => item.positionId));
                return {
                    ...data,
                    positions: newArray
                }
            })
        }
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {}),
        useSensor(TouchSensor, {}),
        useSensor(KeyboardSensor, {})
    )

    const dataIds = useMemo<UniqueIdentifier[]>(
        () => data.positions?.map(({ positionId }) => 'position-' + positionId),
        [data]
    );


    const findRate = useCallback((positionId: number) => {
        const found = data.rates.find(item => item.positionId === positionId && item.stillWorks)
        return found ? found.ratePerHour : null
    }, [data.rates]);


    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header" style={{ height: '55px' }}>
                    <div className="row">
                        <div className="col-6">
                            <h5 className="mt-2">
                                <FontAwesomeIcon fixedWidth icon={["fas", "code-compare"]} /> Pozície
                            </h5>
                        </div>
                        <div className="col-6 text-end">
                            <Link to="/dashboard/position/0" className="btn btn-success"><FontAwesomeIcon fixedWidth icon={["fas", "plus"]} /> Pridať pozíciu</Link>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <DndContext collisionDetection={closestCenter} modifiers={[restrictToVerticalAxis]} onDragEnd={handleDragEnd} sensors={sensors}>
                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}></th>
                                    <th style={{ width: '300px' }}>Meno</th>
                                    <th>Popis</th>
                                    <th className="text-center" style={{ width: '250px' }}>Aktuálna hodinová sadzba</th>
                                    <th className="text-center" style={{ width: '110px' }}>Stav</th>
                                    <th className="text-center" style={{ width: '110px' }}>Akcia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <SortableContext items={dataIds} strategy={verticalListSortingStrategy}>
                                    {
                                        data.positions.map(position => {
                                            return (
                                                <DraggableRow key={'position-' + position.positionId} position={position} findRate={findRate} />
                                            )
                                        })
                                    }
                                </SortableContext>
                            </tbody>
                        </table>
                    </DndContext>
                </div>
            </div>
        </div>
    )
}



function DraggableRow({ position, findRate }: { position: AdminQueryPosition, findRate: Function }) {
    const { transform, transition, setNodeRef, isDragging, attributes, listeners } = useSortable({
        id: 'position-' + position.positionId,
    })

    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        opacity: isDragging ? 0.8 : 1,
        zIndex: isDragging ? 1 : 0,
        position: 'relative',
    }
    return (
        <tr ref={setNodeRef} style={style}>
            <td className="text-center">
                <div {...attributes} {...listeners}>
                    <FontAwesomeIcon fixedWidth icon={["fas", "grip-vertical"]} />
                </div>
            </td>
            <td>{position.name}</td>
            <td>{position.description}</td>
            <td className="text-center">{findRate(position.positionId)}</td>
            <td className="text-center">{position.status ? <span className="text-success">Aktívna</span> : <span className="text-danger">Neaktívna</span>}</td>
            <td className="text-center"><Link className="btn btn-primary btn-sm" to={"/dashboard/position/" + position.positionId}><FontAwesomeIcon fixedWidth icon={["fas", "pen"]} /> Upraviť</Link></td>
        </tr>

    )
}



export default Positions